import dva from './dva'
import React from 'react'
import {Provider} from 'react-redux'
import {persistStore} from 'redux-persist'
import {PersistGate} from 'redux-persist/es/integration/react'
import magento from '@womcorp/gatsby-theme-wom-magento/src/models'
import browser from '@womcorp/gatsby-theme-wom-browse/src/models'
import core from '@womcorp/gatsby-theme-wom-core/src/models'
import checkout from '@womcorp/gatsby-theme-wom-checkout/src/models'
import tmf from '@womcorp/gatsby-theme-wom-tmf/src/models'
import contentful from '@womcorp/gatsby-theme-wom-contentful/src/models'

let _store
export const getStore = () => _store

export default ({element}, plugin) => {
    _store = dva(window.models)._store
    let persistor = persistStore(_store)
    return <Provider store={_store}>{element}</Provider>
}

export const wrapRootProvider = ({element}, plugin) => {
    const app = dva([
        ...magento,
        ...browser,
        ...core,
        ...checkout,
        ...tmf,
        ...contentful,
    ])
    const store = app._store
    let persistor = persistStore(store)
    return <Provider store={store}>{element}</Provider>
}
